import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { devLog } from "@/lib/devLog";

export default function Barcode({ value, height = 56, width = 1.6 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      try {
        JsBarcode(ref.current, value, {
          format: "CODE128",
          height,
          width,
          margin: 4,
          fontSize: 14,
          displayValue: true,
        });
      } catch (err) {
        // Non-fatal: invalid input for CODE128 just leaves the SVG empty.
        if (process.env.NODE_ENV !== "production") {
          devLog("Barcode render failed", value, err);
        }
      }
    }
  }, [value, height, width]);
  return <svg ref={ref} data-testid="barcode-svg" />;
}
